<script lang="ts">
    import { setContext } from 'svelte'
    import { writable } from 'svelte/store'

    import { altLanguages, lg } from 'hydria/services/language'
    import { revalidating, session, signedIn, user } from 'hydria/services/session'

    // IMPORTANT: pour l’immédiat, les notifications ne sont PAS initialisées
    // dans le site publique. Si on vient à en avoir besoin, les placer dans topBar?
    setContext('signed-in-context', writable('public'))
</script>

<main>
    <div id="navigation-bar" class:revalidating={$revalidating}>
        <div class="site-text"></div>
        {#if $signedIn}
            <div class="client-area">
                <a href="/client/">{$lg == 'fr' ? 'Espace client' : 'Client area'}</a>
            </div>
        {/if}
        {#each $altLanguages as altLg (altLg.lg)}
            <div class="alt-lg"><a href="/{altLg.lg}/">{altLg.text}</a></div>
        {/each}
        {#if $signedIn && $user && $user.name != null}
            <div class="user-name">{$user.name}</div>
        {/if}
        <div class:sign-out={$signedIn} class:sign-in={!$signedIn}>
            {#if $signedIn}
                <a
                    href="/{$lg}/"
                    onclick={(event) => {
                        event.preventDefault()
                        session.signout()
                    }}>{$lg == 'fr' ? 'Quitter' : 'Sign out'}</a
                >
            {:else}
                <a href="/{$lg}/">{$lg == 'fr' ? 'Connexion' : 'Sign in'}</a>
            {/if}
        </div>
    </div>
</main>
